/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useState } from "react";

enum LocalStorageKey {
  NAME = "CustomerName",
  ID = "CustomerId",
  ORG_NAME = "klarityOrgName",
}

function setCustomer(
  customerId: string,
  customerOrganization: string,
  customerName?: string
) {
  localStorage.setItem(LocalStorageKey.ID, customerId);
  localStorage.setItem(LocalStorageKey.NAME, customerName || customerId);
  localStorage.setItem(LocalStorageKey.ORG_NAME, customerOrganization);
}

export function getCustomer() {
  const customerId = localStorage.getItem(LocalStorageKey.ID);
  const customerName = localStorage.getItem(LocalStorageKey.NAME);
  const customerOrganization = localStorage.getItem(LocalStorageKey.ORG_NAME);

  if (customerId != null) {
    return {
      id: customerId,
      name: customerName ?? customerId,
      organizationName: customerOrganization ?? "",
    };
  }

  return null;
}

type SavedCustomer = { id: string; name: string; organizationName: string };

export function useCustomerSelector() {
  const [selectedCustomer, setSelectedCustomer] =
    useState<SavedCustomer | null>(getCustomer());

  const selectCustomer = (id: string, name: string, orgName: string) => {
    setCustomer(id, orgName, name);
    setSelectedCustomer({ id, name, organizationName: orgName });
  };

  return {
    selectedCustomer,
    selectCustomer,
  };
}
